// @flow
import * as React from 'react';

import clsx from 'clsx';

import styles from './Flags.scss';

type FlagProps = {
  active: boolean,
  existing: boolean,
  flag: string,
  title: string,
};

function Flag({
  active,
  existing,
  flag,
  title,
}: FlagProps): React.MixedElement {
  return (
    <span
      title={title}
      className={clsx(
        styles.flag,
        active ? styles.active : existing && styles.exiting,
      )}
    >
      {flag}
    </span>
  );
}

const flags = [
  { flag: '🇫🇷', label: '.fr' },
  { flag: '🇨🇦', label: '.ca' },
  { flag: '🇬🇧', label: '.uk' },
  { flag: '🇧🇪', label: '.be' },
  { flag: '🇩🇪', label: '.de' },
  { flag: '🇪🇺', label: '.eu' },
  { flag: '🇳🇱', label: '.nl' },
];

export function Flags(): React.MixedElement {
  const [currentFlagIndex, setCurrentFlagIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFlagIndex(prev => (prev + 1) % flags.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.carousel}>
      {flags.map(({ flag, label }, index) => (
        <Flag
          key={label}
          title={label}
          active={index === currentFlagIndex}
          existing={
            index === (currentFlagIndex - 1 + flags.length) % flags.length
          }
          flag={flag}
        />
      ))}
    </div>
  );
}
